module.exports = __webpack_public_path__ + "static/media/search.05262e08.svg";